/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CoreModule } from '@dm/core';
import { CreateFsScanMissionPolicyCardModule } from 'app/feature/settings/file-storage-service/antivirus/antivirus-policy/filesystem-scan-mission/create-fs-scan-mission-policy-card/create-fs-scan-mission-policy-card.module';

import { FrontTableUserQuotaModule } from '../../quota/user-quota/front-table-user-quota/front-table-user-quota.module';
import { CopyFromCifsShareModule } from '../../share/cifs-share/copy-from-cifs-share/copy-from-cifs-share.module';
import { CopyFromDataTurboShareModule } from '../../share/data-turbo-share/copy-from-data-turbo-share/copy-from-data-turbo-share.module';
import { CopyFromNfsShareModule } from '../../share/nfs-share/copy-from-nfs-share/copy-from-nfs-share.module';
import { CreateFileSystemComponent } from './create-file-system.component';
import { UnixPermissionConfigCardModule } from './unix-permisssion-config-card/unix-permisssion-config-card.module';
import { WormConfigCardModule } from './worm-config-card/worm-config-card.module';

@NgModule({
    declarations: [CreateFileSystemComponent],
    exports: [CreateFileSystemComponent],
    imports: [
        CommonModule,
        CoreModule,
        ReactiveFormsModule,
        FormsModule,
        CopyFromCifsShareModule,
        CopyFromNfsShareModule,
        CopyFromDataTurboShareModule,
        FrontTableUserQuotaModule,
        WormConfigCardModule,
        CreateFsScanMissionPolicyCardModule,
        UnixPermissionConfigCardModule,
    ],
})
export class CreateFileSystemModule { }
